import Vue from 'vue'
import * as auth0 from '@auth0/auth0-spa-js'
import jwtDecode from 'jwt-decode'
import {parseActiveDirectoryUserId} from '@/utilities/utils'
const { VUE_APP_API_PTRAC_AUDIENCE } = process.env

const DEFAULT_REDIRECT_CALLBACK = async () => {
  await getInstance().$router.push('/')
}

let instance

export const getInstance = () => instance

export const useAuth0 = ({
                           onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
                           redirectUri = window.location.origin,
                           ...options
                         }) => {
  if (instance) {
    return instance
  }

  instance = new Vue({
    data() {
      return {
        loading: true,
        sgsd: false,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      }
    },
    methods: {
      verifyIsAuthenticated() {
        if (!this.auth0Client) {
          console.error('isAuthenticated - Auth0 client not initialized yet')
          return
        }
        return this.auth0Client.isAuthenticated()
      },
      loginWithRedirect(o) {
        if (!this.auth0Client) {
          console.error('loginWithRedirect - Auth0 client not initialized yet')
          return
        }
        return this.auth0Client.loginWithRedirect(o)
      },
      getIdTokenClaims(o) {
        if (!this.auth0Client) {
          console.error('getIdTokenClaims - Auth0 client not initialized yet')
          return
        }
        return this.auth0Client.getIdTokenClaims(o)
      },
      getTokenSilently(o) {
        if (!this.auth0Client) {
          console.error('getTokenSilently - Auth0 client not initialized yet')
          return
        }
        return this.auth0Client.getTokenSilently(o)
      },
      async logout(o) {
        if (!this.auth0Client) {
          console.error('logout - Auth0 client not initialized yet')
          return
        }
        await options.$store.dispatch('security/logout')
        return this.auth0Client.logout(o)
      },
      async hydrateSecurityUser() {
        const authToken = await this.getTokenSilently()
        const jwt = jwtDecode(authToken)
        const userId = parseActiveDirectoryUserId(this.user.sub)

        options.$store.commit('security/userId', userId)
        options.$store.commit('security/userGroups', jwt['ptrac_groups'])

        return jwt
      }
    },
    async created() {
      this.auth0Client = await auth0.createAuth0Client({
          ...options,
          authorizationParams: {
            redirect_uri: options.redirect_uri,
            ...options.authorizationParams,
            audience: VUE_APP_API_PTRAC_AUDIENCE,
            scope: 'openid profile email offline_access',
          }
        })

      try {
        this.isAuthenticated = await this.auth0Client.isAuthenticated()
        this.user = await this.auth0Client.getUser()

        if (this.user) {
          await this.hydrateSecurityUser()
        }

        if (
          window.location.search.includes('code=') &&
          window.location.search.includes('state=')
        ) {
          await this.auth0Client.handleRedirectCallback()
          const authToken = await this.getTokenSilently()

          this.user = await this.auth0Client.getUser()

          if (!this.user) {
            console.error('Auth0 user not found. Unable to authenticate.')
            return
          }

          // if the user object exists, then a user is authenticated
          this.isAuthenticated = true

          localStorage.setItem('accessToken', authToken)

          const jwt = await this.hydrateSecurityUser()

          // add groups to the currently logged-in user - this is required for ability.js to work
          // and affects what shows up in the sidebar menu system
          await options.$store.dispatch('users/updateUserGroups', {
            id: parseActiveDirectoryUserId(this.user.sub),
            groups: jwt['ptrac_groups']
          })

          await options.$store.dispatch('logs/logLogin', this.user)
          const idTokenClaims = await this.auth0Client.getIdTokenClaims()
          localStorage.setItem('idToken', JSON.stringify(idTokenClaims))
          await onRedirectCallback()
        }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    }
  })

  return instance
}

export const Auth0Plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options)
  }
}
